export const isAdminRole = (role) => {
    if (role === 1 || role === "1") return true;
    if (typeof role === "string") {
        return role.trim().toLowerCase() === "admin";
    }
    return false;
};
